import { Injectable, Optional } from "@angular/core";
import { Firestore } from "@angular/fire/firestore";
import { ElasticSearchService, ESExtras } from "@common/api-server";
import { EsFirestoreBase } from "@common/helpers/es-firestore-base";
import { ProjectModel } from "@shared/models/project.model";



const ES_EXTRA: ESExtras = {
  'name': {
    type: "text"
  },
  'displayName': {
    type: "text"
  }
}

const ES_SOURCE = null; 
const DATE_PROPERTIES = ['createdAt', 'updatedAt'];
const UTC_DATE_PROPERTIES = ['baseline', 'period'];

export type Model = ProjectModel;
const collectionName = 'projects'
@Injectable({
  providedIn: 'root'
})
export class ProjectDbService extends EsFirestoreBase<ProjectModel>{
  override collectionName = collectionName;
  constructor(
    @Optional() protected override firestore: Firestore,
    protected override es: ElasticSearchService,

  ) {
    super(firestore, es, collectionName, ES_EXTRA, ES_SOURCE, DATE_PROPERTIES, {utcDateProperties: UTC_DATE_PROPERTIES});

  }

}
